import React from "react";
export const TodaysRequestIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="#123262"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12,6 12,12 16,14" />
    </svg>
  );
};
